import { useCurrentLang } from '$hooks/useCurrentLang';
import { transliterate } from '$utils';
import { useMemo } from 'react';

export const useTransliterateName = (name: string) => {
  const { key } = useCurrentLang();

  return useMemo(() => {
    if (key !== 'ru') {
      return transliterate(name);
    }

    return name;
  }, [name, key]);
};
